import { useEffect, useState } from 'react';
import { useServices } from '@insync-students-lib/hooks/useServices';
import { Assignment } from '@insync-students-lib/models/assigment/assigment.model';
import { serializeAssignment } from '@insync-students-utils/transformers/assignment/assignment.transformer';
type UseAssignmentResponse = {
  assignment: Assignment | null;
  error: Error | null;
};
export function useAssignment(assignmentId: string): UseAssignmentResponse {
  const {
    assignmentsService
  } = useServices();
  const [assignment, setAssignment] = useState<Assignment | null>(null);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    if (!assignmentsService) {
      return;
    }
    const filteredAssignmentId = assignmentId.replace(/&curriculumId=.*$/, '');
    assignmentsService.getResourceByAssignment(filteredAssignmentId).then(assignmentResource => {
      const serializedAssignment = serializeAssignment({
        ...assignmentResource.assignment,
        resourceId: assignmentResource.resourceId,
        parentId: assignmentResource.parentId,
        parentType: assignmentResource.parentType
      });
      setAssignment(serializedAssignment);
    }).catch(error => {
      setError(error);
    });
  }, [assignmentId, assignmentsService]);
  return {
    assignment,
    error
  };
}